import * as React from 'react';
import ReactModal from 'react-modal';
import { IParentModalContext } from './context';
import { contentClasses, css, overlayClasses, overlayTransitionTimeInMs, styleSheet } from './styles';

interface IProps<TResult = any> {
	isOpen: boolean;
	onRequestClose?(result?: TResult, canceled?: boolean): void;
	shouldCloseOnOverlayClick?: boolean;
}

ReactModal.setAppElement('#react-root');

export const Modal: React.FC<IProps> = props => {
	const { isOpen, children, onRequestClose: requestClose, shouldCloseOnOverlayClick } = props;

	const onRequestClose = React.useCallback(
		(result?: any, canceled?: boolean) => {
			requestClose?.(result, canceled);
		},
		[requestClose]
	);
	const [context, setContext] = React.useState<IParentModalContext>({
		onRequestClose,
	});
	const contextRef = React.useRef<IParentModalContext>(context);
	contextRef.current = context;
	React.useEffect(() => {
		setContext({
			...contextRef.current,
			onRequestClose,
		});
	}, [onRequestClose]);
	return (
		<ReactModal
			bodyOpenClassName={null}
			className={contentClasses}
			closeTimeoutMS={overlayTransitionTimeInMs}
			isOpen={isOpen}
			overlayClassName={overlayClasses}
			portalClassName={`modal ${css(styleSheet.modal, isOpen ? styleSheet.modalActive : null)}`}
			shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
		>
			{children}
		</ReactModal>
	);
};
